import AppModel from '@/models/AppModel'
import store from '@/store/model-store'

const isDebug = process.env.NODE_ENV !== 'production'

export default {
  postApi: (bvModal, params = null, callbackFinally) => {
    return AppModel.post(
      'delivered/sheets',
      bvModal,
      params,
      (res) => {
        if (isDebug) {
          console.log(res.data)
        }

        AppModel.validateStatus(res.data)

        let modelStore = store.getters.model
        if (!modelStore) {
          modelStore = {}
        }

        modelStore['delivered_sheets'] = res.data
        store.commit('setModel', modelStore)

        return Promise.resolve(res.data)
      },
      callbackFinally
    )
  },
  getStore: (key) => {
    return AppModel.getStore('delivered_sheets', key)
  },
  removeStore: () => {
    delete store.getters.model.agenda
  }
}



// WEBPACK FOOTER //
// ./src/models/DeliveredSheetsModel.js